import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "18", cy: "5", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "6", cy: "12", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "18", cy: "19", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Share2";
const Share2 = memo(themed(Icon));
export {
  Share2
};
//# sourceMappingURL=share-2.js.map
